import React from 'react';
import { sponsorTierGroups } from '../data/sponsors';
import SponsorCard from '../components/shared/SponsorCard';
import './SponsorsPage.css';

// Full sponsor listing grouped by tier (Diamond -> Bronze), preserving the
// tier prominence that the homepage marquee flattens.
const SponsorsPage = () => {
  return (
    <section className="sponsors-page fade-in-up">
      <div className="sponsors-page-wrapper">
        <span className="badge sponsors-page-badge">Special Thanks to</span>
        <h1 className="sponsors-page-heading">Our Sponsors</h1>
        <p className="sponsors-page-subtitle">
          We are grateful to the following organisations for their generous support of ICES2026.
        </p>

        {sponsorTierGroups.map((group) => (
          <div className="sponsor-tier-group" key={group.tier}>
            <h2 className="sponsor-tier-heading">
              <span className={`sponsor-tier-heading__badge sponsor-card__tier--${group.tier.toLowerCase()}`}>
                {group.tier} Sponsor{group.sponsors.length > 1 ? 's' : ''}
              </span>
            </h2>
            <div className="sponsor-tier-cards">
              {group.sponsors.map((sp, i) => (
                <SponsorCard sponsor={sp} index={i} variant="full" key={sp.name} />
              ))}
            </div>
          </div>
        ))}

        <p className="sponsors-page-contact">
          Interested in sponsoring ICES2026? Contact us at{' '}
          <a href="mailto:ices2026@uq.edu.au">ices2026@uq.edu.au</a>.
        </p>
      </div>
    </section>
  );
};

export default SponsorsPage;
